import styled from '@emotion/styled/macro'
import mediaQuery from 'share/utils/mediaQuery'

import { pageContentDefaultSize } from 'style/emotion'

const QuestionnaireOverviewPageWrapper = styled('section')`
  ${pageContentDefaultSize}
`

const QuestionnaireOverviewPage = styled('section')`
  color: var(--CINight);
  margin-top: 48px;

  > h2 {
    margin-bottom: 16px;
    color: var(--print-main);
    line-height: 20px;
  }

  ${mediaQuery('tablet')} {
    margin-top: 24px;
  }
`
const QuestionnaireNotification = styled('section')`
  margin-top: 48px;
  font-size: 14px;
  font-weight: 400;
  color: var(--CINight);
  display: flex;
  white-space: pre-line;

  ${mediaQuery('tablet')} {
    margin-top: 24px;
  }

  > div {
    background-color: #eaf2f8;
    padding: 8px;
    border: 1px solid #2a7ab7;
  }

  &.joint {
    @media (min-width: 769px) {
      margin-bottom: -24px;
    }
  }

  &.questionnaire-rejected {
    margin-top: 48px;
    > div {
      background-color: #fdf7e9;
      padding: 8px;
      border: 1px solid #8d6613;
      .mdi-alert {
        color: #8d6613;
      }
    }

    &.joint {
      margin-bottom: -40px;
      ${mediaQuery('tablet')} {
        margin-bottom: -16px;
      }
    }

    &.single {
      @media (min-width: 769px) {
        margin-bottom: -24px;
      }
    }
    ${mediaQuery('tablet')} {
      margin-top: 24px;
    }
  }

  &.questionnaire-submitted {
    margin-top: 48px;

    > div {
      background-color: #e8f6ed;
      padding: 8px;
      border: 1px solid #16a550;
      .mdi-check-circle {
        color: #16a550;
      }
    }
    &.joint {
      margin-bottom: -40px;
      ${mediaQuery('tablet')} {
        margin-bottom: -16px;
      }
    }
    &.single {
      @media (min-width: 769px) {
        margin-bottom: -24px;
      }
    }

    ${mediaQuery('tablet')} {
      margin-top: 24px;
    }
  }

  .blue-info-icon {
    color: var(--skydiver);
    fontsize: 16px;
  }

  @media (min-width: 769px) {
    margin-bottom: -24px;
  }
`

const QuestionnaireCompletionDateContainer = styled('div')`
  margin-top: 16px;
  font-size: 14px;
  font-weight: 500;
  color: var(--print-secondary);
  background-color: #eaf2f8;
  display: flex;
  white-space: pre-line;
  padding: 8px;

  .mdi-information-outline:before {
    margin-left: 8px;
    font-size: 18px;
  }
`

const QuestionnaireCompleteSectionHelperText = styled('div')`
  margin-top: 16px;
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 400;
  color: var(--print-secondary);
`

const QuestionnaireSectionSummary = styled('div')`
  color: var(--print-main);
  > h6 {
    font-weight: 400;
  }
`

const CardsWrapper = styled('div')`
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  width: inherit;

  & .badge {
    background-color: var(--CINight-10);
    border: 1px solid var(--gray-1);
    color: var(--CINight);
    font-weight: 400;
    padding: 4px 8px;
  }

  & .ui-go-to-case-btn {
    width: 100%;
  }

  > .card {
    border-radius: 3px;
    box-shadow: 2px 2px 2px 0px var(--gray-2);
    -webkit-box-shadow: 2px 2px 2px 0px var(--gray-2);
    flex-basis: 100%;
    padding: 20px;
    margin-top: 20px;

    .mdi-clock-outline {
      color: #ebaa20;
      font-size: 25px;
      line-height: 25px;
    }
    .mdi-check-circle-outline {
      color: #16a550;
      font-size: 25px;
      line-height: 25px;
    }

    .font-bold {
      font-weight: 500;
      font-size: 12px;
      color: var(--CINight);
    }

    .font-light {
      font-weight: 400;
      font-size: 12px;
      color: var(--CINight);
    }

    ${mediaQuery('', 'tablet')} {
      flex-basis: calc(50% - 8px);

      :nth-of-type(even) {
        margin-left: 16px;
      }
    }
  }
`

export {
  CardsWrapper,
  QuestionnaireOverviewPageWrapper,
  QuestionnaireOverviewPage,
  QuestionnaireCompletionDateContainer,
  QuestionnaireCompleteSectionHelperText,
  QuestionnaireSectionSummary,
  QuestionnaireNotification
}
